import { defaultSection } from './default'
import { objToList } from './index'
import { getFormData } from './form'
import { getField } from './fields'

const useGroupImagesField = {
    "name": "useGroupImages",
    "label": "引用套图",
    "type": "COMPLEX",
    "rules": {},
    isShowFn(form) {
        return form.showGroupImages === undefined ? true : form.showGroupImages
    }
}
/**
 * 根据默认配置从接口数据捞出需要的数据(接口会返回所有数据)
 * @param {*} data 
 */
export const generateSections = (data = {}, options = {}) => {
    if (Object.keys(data).length <= 0) return
    // 将主图images中rule.maxTargetSizeRule移到商品规格图片中
    data['useGroupImages'] = useGroupImagesField
    let images = data['images'];
    if (images) {
        let maxTargetSizeRule = images.rules?.maxTargetSizeRule;
        if (maxTargetSizeRule) {
            data['saleProp'].imgRules = {
                limitSize: Number(maxTargetSizeRule)
            }
        }
    }
    const formFields = objToList(data)

    // 对采购地做rule处理，将globalStock的rules移动至子中的globalStockNav
    // let globalStock = formFields.find(item => item.name === 'globalStock')
    // if (globalStock) {
    //     let globalStockNav = globalStock.children.find(item => item.name === 'globalStockNav')
    //     if (globalStockNav) {
    //         console.log(globalStockNav)
    //         globalStockNav.rules = {
    //             ...globalStockNav.rules,
    //             ...globalStock.rules
    //         }
    //         globalStock.rules = {}
    //     }
    // }

    formFields.forEach(item => {
        if(item.name && /\./.test(item.name)) {
            // 对于name字段中含有.的进行替换为_____（5个下划线），不然在el-form-item中prop属性时会报错
            item.propName = item.name.replaceAll('.', '_____') 
        }
        if(item.name === 'globalStock') {
            // 对采购地做rule处理，将globalStock的rules移动至子中的globalStockNav
            let globalStockNav = item.children.find(childItem => childItem.name === 'globalStockNav')
            if (globalStockNav) {
                globalStockNav.rules = {
                    ...globalStockNav.rules,
                    ...item.rules
                }
                item.rules = {}
            }
        }
    })

    // 按照默认配置获取数据
    const formSections = defaultSection.reduce((list, item) => {
        let fields = item.fieldsMatch.reduce((fields, { reg }) => {
            let list = formFields.filter(item2 => reg.test(item2.name)) // 捞需要显示的数据
            let field = getField(list) // 生成 field
            return fields.concat(field)
        }, [])
        if(item.title === '图文描述'){
            const descIndex = fields.findIndex(f => f.name === 'desc')
            const wirelessDescIndex = fields.findIndex(f => f.name === 'wirelessDesc')
            // 交换desc、wirelessDesc的位置,使wirelessDesc显示在desc前面
            if (descIndex !== -1 && wirelessDescIndex !== -1 && descIndex !== wirelessDescIndex && descIndex < wirelessDescIndex) {
                const temp = fields[descIndex]
                fields[descIndex] = fields[wirelessDescIndex]
                fields[wirelessDescIndex] = temp
            }
        }
        return list.concat({
            title: item.title,
            children: fields
        })
    }, [])

    let formData = getFormData(formSections); // 生成 form 表单对象
    if (options.isUpdateCatPropSecondary) {
        formData.newWirelessDesc = options.tbForm.newWirelessDesc || []
    } else {
        formData.newWirelessDesc = []
    }
    return { formData, formSections }
}
